import {FC, Fragment, useMemo} from 'react'
import {TermsDocument} from '../core/_models'
import {parseTermsMarkdown, TermsInline} from '../core/termsMarkdown'
import {formatTermsDay, formatTermsVersion} from '../core/termsFormat'

const Inlines: FC<{inlines: TermsInline[]}> = ({inlines}) => (
  <>
    {inlines.map((inline, index) => {
      if (inline.type === 'strong') return <strong key={index}>{inline.text}</strong>
      if (inline.type === 'link')
        return (
          <a key={index} href={inline.href} target='_blank' rel='noopener noreferrer'>
            {inline.text}
            <span className='visually-hidden'> (در زبانه جدید)</span>
          </a>
        )
      return <Fragment key={index}>{inline.text}</Fragment>
    })}
  </>
)

export const TermsContent: FC<{content: string}> = ({content}) => {
  const blocks = useMemo(() => parseTermsMarkdown(content), [content])

  return (
    <div className='mp-terms-text'>
      {blocks.map((block, index) => {
        if (block.type === 'heading')
          return (
            <h3 key={index}>
              <Inlines inlines={block.inlines} />
            </h3>
          )
        if (block.type === 'list')
          return (
            <ul key={index}>
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <Inlines inlines={item} />
                </li>
              ))}
            </ul>
          )
        return (
          <p key={index}>
            <Inlines inlines={block.inlines} />
          </p>
        )
      })}
    </div>
  )
}

// What changed since the previous version, shown above the text of an updated version.
export const TermsChanges: FC<{document: TermsDocument}> = ({document}) =>
  document.changes.length > 0 ? (
    <section className='mp-terms-changes' aria-labelledby={`mp-terms-changes-${document.version}`}>
      <h3 id={`mp-terms-changes-${document.version}`}>
        <i className='las la-pen-fancy' aria-hidden='true' /> تغییرات این نسخه
      </h3>
      <ul>
        {document.changes.map((change, index) => (
          <li key={index}>{change}</li>
        ))}
      </ul>
    </section>
  ) : null

export const TermsDocumentView: FC<{document: TermsDocument}> = ({document}) => (
  <article className='mp-terms-document' aria-labelledby={`mp-terms-title-${document.version}`}>
    <header className='mp-terms-document__header'>
      <h2 id={`mp-terms-title-${document.version}`}>{document.title}</h2>
      <p>
        <span className='mp-terms-badge'>{formatTermsVersion(document.version)}</span>
        <span>آخرین به‌روزرسانی: {formatTermsDay(document.effectiveDay)}</span>
      </p>
    </header>
    <TermsContent content={document.content} />
  </article>
)
